import { Signal } from '@preact/signals'
import { useRoute } from 'wouter-preact'

import { Button, Modal, TextLink, Typography } from 'components/UI'

type Props = {
	isModalOpen: Signal<boolean>
	onCloseLogoutModal: () => void
	logout: () => void
}

const LogoutModal = ({ isModalOpen, onCloseLogoutModal, logout }: Props) => {
	const [isOnWorkspacePage] = useRoute('/smart-contract/:dAppName/workspace')

	return (
		<Modal
			className='space-y-10 p-10'
			isOpen={isModalOpen.value}
			onCloseModal={onCloseLogoutModal}
		>
			<Typography
				color='text-product'
				text='Are you sure you want to sign out?'
				variant='h2'
			/>

			<Typography
				color='text-black-100'
				text={
					isOnWorkspacePage
						? 'You have a workspace open, any unsaved changes will be lost.'
						: 'If you have a workspace open, any unsaved changes will be lost.'
				}
				variant='text1'
			/>

			<div class='flex justify-between'>
				<TextLink
					ariaLabel='Cancel'
					onClick={onCloseLogoutModal}
					text='Cancel'
					variant='secondary'
				/>

				<Button onClick={logout} text='Sign out' variant='error' />
			</div>
		</Modal>
	)
}

export { LogoutModal }
